<div *ngIf="formGroup"
     [formGroup]="formGroup">

  <div class="row no-gutters mb-input-margin-bottom">
    <div class="col-12 field-wrapper" mbFloatingLabel
         data-cy="mb-customer-number">
      <label for="customerNumber" [ngClass]="[isFormDisabled ? 'mb-disable-label' : '', 'mb-input-field-cursor mb-custom-label']">{{ customerNoLabelKey | cxTranslate }}</label>
      <input class="w-100 mb-form-input mb-custom-label"
             type="text"
             id="customerNumber"
             name="customerNumber"
             formControlName="customerNumber"
             data-cy="mb-customer-number-input"/>
    </div>
  </div>

</div>
